import React from "react";
import "../styles/layout.css";
import CustomButton from "./CustomButton";

export default function ConfirmDialog({
  isOpen,
  title = "Confirm Action",
  message = "Are you sure?",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  destructive = false,
}) {
  if (!isOpen) return null;

  return (
    <div className="confirm-dialog-overlay" onClick={onCancel}>
      <div
        className="confirm-dialog-card"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="confirm-dialog-header">
          <h3>{title}</h3>
        </div>

        <p className="confirm-dialog-message">{message}</p>

        <div className="confirm-dialog-actions">
          <CustomButton
            className="confirm-dialog-cancel"
            label={cancelLabel}
            onClick={onCancel}
          />
          <CustomButton
            className={destructive ? "confirm-dialog-delete" : "confirm-dialog-confirm"}
            label={confirmLabel}
            onClick={onConfirm}
          />
        </div>
      </div>
    </div>
  );
}
